module.exports = __webpack_public_path__ + "static/media/icon_home_admin.a2218ff3.svg";